import React, { useEffect, useRef, useState } from 'react';
import { ArrowRight, CheckCircle, Phone, Mail, Clock, MapPin , User, Send,} from 'lucide-react';
import {
    Stethoscope,
    HeartPulse,
    Syringe,
    UserCheck,
    FlaskConical,
    Baby,
    UserPlus,
    Hospital,
    ShieldCheck,
    CheckCircle2,
    Salad,
    HelpingHand,
    Home,
    PhoneCall,
} from "lucide-react";
import emailjs from "emailjs-com";
import ServiceCall from "../ServiceCall";
import HospitalTreatmentsShowcase from "./HospitalTreatmentsShowcase";
const Homecare = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
    const formRef = useRef(null);
const services = [
  { title: "Physio therapy", description: "Expert physiotherapy services at home.", icon: <HeartPulse /> },
  { title: "Nursing", description: "Compassionate and skilled nursing care.", icon: <HeartPulse /> },
  { title: "Medical Equipment", description: "Rent or buy medical devices delivered home.", icon: <Stethoscope /> },
  { title: "Trained Attendants", description: "Certified support staff for personal care.", icon: <UserCheck /> },
  { title: "Lab Tests", description: "Home sample collection with accurate results.", icon: <FlaskConical /> },
  { title: "Elder Care", description: "Special care plans tailored for seniors.", icon: <HelpingHand /> },
  { title: "Doctor Consultation", description: "On-demand visits or video consultations.", icon: <Hospital /> },
  { title: "Mother & Baby Care", description: "Postnatal care and newborn monitoring.", icon: <Baby /> },
  { title: "Diabetes Care", description: "Customized diabetic health management.", icon: <CheckCircle2 /> },
  { title: "Critical Care", description: "ICU setup and trained professionals at home.", icon: <ShieldCheck /> },
  { title: "Covid Care", description: "At-home monitoring, treatment, and support.", icon: <ShieldCheck /> },
  { title: "Vaccination", description: "All essential vaccines delivered at home.", icon: <Syringe /> },
  { title: "Counselling", description: "Professional mental health support.", icon: <UserPlus /> },
  { title: "Nutrition & Diet", description: "Diet plans by certified nutritionists.", icon: <Salad /> },
];
 const [showAlert, setShowAlert] = useState(false);
  //  const formRef = useRef(null);
   const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
    const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  const mode = process.env.REACT_APP_MODE; // e.g., 'dev', 'prod'

  const payload = {
    email: formData.email,
    country_code: '+91', // 🔧 Replace with dynamic code if available
    phone: formData.phone,
    name: formData.name,
    address: formData.address,
    source_url: 'https://rxone.app/homecare',
    request_type: 'homecare',
    coupon_code: '' // 🔧 Optional: add value if needed
  };

  try {
    await ServiceCall.post(`/rxopd/rxone/patient/treatment/advice/contactus/form/${mode}`, payload);

    setSubmitted(true);
    setTimeout(() => {
      setFormData({ name: '', email: '', phone: '', address: '' });
      setSubmitted(false);
    }, 3000);
  } catch (error) {
    console.error('API submission error:', error);
    alert('Failed to submit the form. Please try again.');
  } finally {
    setLoading(false);
  }
};

 const features = [
  {
    icon: <Clock className="h-8 w-8" />,
    title: "Qualified Professionals",
    description:
      "Our team consists of certified and experienced healthcare providers dedicated to your wellbeing.",
  },
  {
    icon: <Clock className="h-8 w-8" />,
    title: "24/7 Availability",
    description:
      "We provide round-the-clock services to ensure you receive care whenever you need it.",
  },
  {
    icon: <Home className="h-8 w-8" />,
    title: "Home Comfort",
    description:
      "Receive top-quality healthcare in the familiar and comfortable environment of your home.",
  },
];
const [startCount, setStartCount] = useState(false);
  const [counts, setCounts] = useState({ hospitals: 0, visits: 0, served: 0 });
  const sectionRef = useRef(null);

  const animateCount = (key, target, duration) => {
    let start = 0;
    const stepTime = 20;
    const increment = target / (duration / stepTime);

    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        start = target;
        clearInterval(timer);
      }
      setCounts(prev => ({ ...prev, [key]: Math.floor(start) }));
    }, stepTime);
  };
const StatBox = ({ icon, count, label, suffix = '' }) => (
  <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow text-center">
    <div className="flex justify-center items-center h-16 w-16 mx-auto mb-4 text-[#01a09e]">
      {icon}
    </div>
    <div className="text-4xl font-bold text-[#01a09e] mb-2">
      {count}{suffix}
    </div>
    <p className="text-lg text-gray-700">{label}</p>
  </div>
);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !startCount) {
          setStartCount(true);
          animateCount('hospitals', 63, 1000);
          animateCount('visits', 700000, 1500);
          animateCount('served', 1000000, 1500);
        }
      },
      { threshold: 0.5 }
    );

    const current = sectionRef.current;
    if (current) observer.observe(current);

    return () => {
      if (current) observer.unobserve(current);
    };
  }, [startCount]);
  const statesOfIndia = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
  "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
  "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya",
  "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim",
  "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal"
];





  const resetForm = () => {
    setFormData({
      name: "",
      phone: "",
      email: "",
      message: "",
      state: ""
    });
  };
const [errors, setErrors] = useState({});

const handleSubmit2 = (e) => {
  e.preventDefault();

  const newErrors = {};

  if (!formData.name.trim()) {
    newErrors.name = "Name is required";
  }

  if (!formData.phone.trim()) {
    newErrors.phone = "Phone number is required";
  } else if (!/^\d{10}$/.test(formData.phone)) {
    newErrors.phone = "Phone must be 10 digits";
  }

  if (!formData.email.trim()) {
    newErrors.email = "Email is required";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    newErrors.email = "Email is invalid";
  }

  if (!formData.state) {
    newErrors.state = "State is required";
  }

  if (!formData.message.trim()) {
    newErrors.message = "Please describe your concern";
  }

  setErrors(newErrors);

  if (Object.keys(newErrors).length === 0) {
    // No errors – proceed with submission
    setIsSubmitting(true);
    
    // simulate API call or call your actual submit logic
    setTimeout(() => {
      setSubmitted(true);
      setIsSubmitting(false);
    }, 1000);
  }
};

  return (
    <div className="bg-gradient-to-br from-teal-100 via-white to-blue-50 min-h-screen">
      {/* Hero Section */}
      <section id="consultation" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 mt-20">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
                Professional <span className="text-teal-600">Healthcare</span> Services at Your Doorstep
              </h1>
              <p className="mt-6 text-xl text-gray-600 leading-relaxed">
                Comprehensive medical care and support services delivered directly to your home by experienced healthcare professionals.
              </p>
            </div>
            
            <div className="flex flex-wrap gap-4">
              <a href="#services" className="inline-flex items-center px-6 py-3 bg-teal-600 text-white font-medium rounded-lg shadow-md hover:bg-teal-700 transition-colors">
                Our Services
                <ArrowRight className="ml-2 h-5 w-5" />
              </a>
             <a href="#contact" className="inline-flex items-center px-6 py-3 bg-white text-teal-600 border border-teal-600 font-medium rounded-lg hover:bg-teal-50 transition-colors">
  Contact Us
</a>

            </div>
            
            <div className="space-y-4 pt-2">
              <div className="flex items-center gap-3">
                <div className="bg-teal-100 p-2 rounded-full text-teal-600">
                  <Clock className="h-6 w-6" />
                </div>
                <span className="text-gray-700 font-medium">Certified Medical Professionals</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="bg-teal-100 p-2 rounded-full text-teal-600">
                  <Clock className="h-6 w-6" />
                </div>
                <span className="text-gray-700 font-medium">Available 24/7 For Emergency Care</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="bg-teal-100 p-2 rounded-full text-teal-600">
                  <CheckCircle className="h-6 w-6" />
                </div>
                <span className="text-gray-700 font-medium">Insurance Coverage Assistance</span>
              </div>
            </div>
          </div>
          
          <div>
       <div className="lg:pl-12" ref={formRef}>
  <div className="bg-white rounded-2xl shadow-2xl p-6 lg:p-8 relative overflow-hidden">
    {/* Decorative Elements */}
    <div className="absolute top-0 right-0 w-32 h-32 opacity-10 transform rotate-12">
      <div className="w-full h-full rounded-full" style={{ backgroundColor: 'rgb(1, 154, 158)' }}></div>
    </div>
    <div className="absolute bottom-0 left-0 w-24 h-24 opacity-5 transform -rotate-12">
      <div className="w-full h-full rounded-full" style={{ backgroundColor: 'rgb(1, 154, 158)' }}></div>
    </div>

    {submitted ? (
      <div className="text-center py-4">
        <div className="w-16 h-16 mx-auto mb-3 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(1, 154, 158, 0.1)' }}>
          <CheckCircle className="w-8 h-8" style={{ color: 'rgb(1, 154, 158)' }} />
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-1">Thank You!</h3>
        <p className="text-sm text-gray-600">Your message has been sent successfully. We'll get back to you soon.</p>
      </div>
    ) : (
      <>
       <div className="text-center mb-4">
  <h2 className="text-4xl font-extrabold text-gray-900 mb-3 flex items-center justify-center gap-3">
  <span
    style={{
      letterSpacing: "1px",
      // textTransform: "uppercase",
      background: "linear-gradient(90deg, #019a9e 0%, #00c6b7 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      display: "inline-block"
    }}
  >
    Contact Now 
  </span>
  {/* <img
    src={phantompic}
    alt="PanTum Logo"
    style={{
      display: "inline-block",
      verticalAlign: "middle",
      height: "30px",
      marginBottom: "2px"
    }}
  /> */}
</h2>
  <p className="text-sm text-gray-600">
    Fill out the form and we'll contact you within 24 hours
  </p>
</div>

        <div className="space-y-4">
          {/* Name Field */}
          <div>
            <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
              <User className="w-4 h-4 mr-2 text-gray-500" />
              Full Name *
            </label>
            <input
              type="text"
              name="name"
              placeholder="Enter your full name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
              style={{ '--tw-ring-color': 'rgb(1, 154, 158)' }}
            />
          </div>

          {/* Email Field */}
          <div>
            <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
              <Mail className="w-4 h-4 mr-2 text-gray-500" />
              Email Address *
            </label>
            <input
              type="email"
              name="email"
              placeholder="Enter your email address"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
              style={{ '--tw-ring-color': 'rgb(1, 154, 158)' }}
            />
          </div>

          {/* Phone Field */}
          <div>
            <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
              <Phone className="w-4 h-4 mr-2 text-gray-500" />
              Phone Number *
            </label>
            <input
              type="tel"
              name="phone"
              placeholder="Enter your phone number"
              value={formData.phone}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
              style={{ '--tw-ring-color': 'rgb(1, 154, 158)' }}
            />
          </div>

          {/* Address Field */}
          <div>
            <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
              <MapPin className="w-4 h-4 mr-2 text-gray-500" />
              Address *
            </label>
            <textarea
              name="address"
              placeholder="Enter your complete address"
              rows="2"
              value={formData.address}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white resize-none"
              style={{ '--tw-ring-color': 'rgb(1, 154, 158)' }}
            />
          </div>

          {/* Submit Button */}
          <button
            type="button"
            onClick={handleSubmit}
            disabled={loading}
            className={`w-full flex items-center justify-center px-6 py-3 rounded-lg font-semibold text-white transition-all duration-200 transform hover:scale-105 hover:shadow-lg ${
              loading ? 'opacity-70 cursor-not-allowed' : 'hover:shadow-xl'
            }`}
            style={{
              backgroundColor: loading ? '#gray' : 'rgb(1, 154, 158)',
              boxShadow: loading ? 'none' : '0 4px 15px rgba(1, 154, 158, 0.3)',
            }}
          >
            {loading ? (
              <>
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                Submitting...
              </>
            ) : (
              <>
                <Send className="w-5 h-5 mr-2" />
                Submit
              </>
            )}
          </button>

          {/* Trust Indicators */}
          {/* <div className="pt-3 border-t border-gray-100">
            <div className="flex items-center justify-center space-x-4 text-xs text-gray-500">
              <div className="flex items-center">
                <Shield className="w-4 h-4 mr-1" style={{ color: 'rgb(1, 154, 158)' }} />
                SSL Secured
              </div>
              <div className="flex items-center">
                <CheckCircle className="w-4 h-4 mr-1" style={{ color: 'rgb(1, 154, 158)' }} />
                No Spam
              </div>
              <div className="flex items-center">
                <Star className="w-4 h-4 mr-1" style={{ color: 'rgb(1, 154, 158)' }} />
                Trusted
              </div>
            </div>
          </div> */}
        </div>
      </>
    )}
  </div>
</div>

          </div>
        </div>
      </section>
      
      {/* Services Section */}
    <section id="services" className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900">Our Healthcare Services</h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
            We provide specialized home healthcare services tailored to meet your individual needs.
          </p>
        </div>

     <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
  {services.map((service, index) => (
    <div
      key={index}
      className="bg-blue-50 rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow border border-blue-100"
    >
      <div className="bg-teal-100 w-12 h-12 rounded-full flex items-center justify-center mb-4 text-teal-600">
        {service.icon}
      </div>
      <h3 className="text-xl font-bold text-gray-900 mb-2">{service.title}</h3>
      <p className="text-gray-600 text-sm">{service.description}</p>
     <a
  href="#consultation"
  className="mt-4 inline-flex items-center text-teal-600 font-medium hover:text-teal-700"
>
  Learn more
  <ArrowRight className="ml-2 h-4 w-4" />
</a>
    </div>
  ))}
</div>
      </div>
    </section>
      <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Why Choose <span className="text-[#01a09e]">Our Services</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We are committed to providing the highest quality healthcare in the comfort of your home.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center p-6 rounded-xl border shadow hover:shadow-md transition duration-300">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-tr from-teal-500 to-teal-400 flex items-center justify-center text-white">
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold mb-3">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
     <section ref={sectionRef} className="py-10 bg-gray-50">
         <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Our Impact <span className="text-[#01a09e]">Across India</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
           We take pride in partnering with top hospitals, delivering trusted care, and serving millions of patients every year across the country.

          </p>
        </div>
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8">
          <StatBox
            icon={
              <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
            }
            count={counts.hospitals}
            label="Top Hospital Partnerships"
          />
          <StatBox
            icon={
              <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
            }
            count={counts.visits.toLocaleString()}
            label="Annual Patient Visits across India"
            suffix="+"
          />
          <StatBox
            icon={
              <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
            }
            count={counts.served.toLocaleString()}
            label="Patients Served Successfully"
            suffix="+"
          />
        </div>
      </div>
    </section>
    <section id="locations" className="bg-white py-16">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
  <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
           Services Available In <span className="text-[#01a09e]">Across India</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
           Our expert care teams are available across multiple cities in India to deliver trusted, personalized healthcare at your doorstep.

          </p>
        </div>

  {/* <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
  {[
    "Bangalore", "NCR-Delhi", "Mumbai", "Agra", "Siliguri", "Meerut", "Surat", "Madurai",
    "Vellore", "Chennai", "Kolkata", "Hyderabad", "Pune", "Lucknow", "Chandigarh", "Jaipur",
    "Gwalior", "Raipur", "Indore", "Kochi", "Kozhikode", "Thrissur", "Guwahati", "Visakhapatnam",
    "Vijayawada", "Ludhiana", "Mysuru", "Coimbatore", "Salem", "Nagpur", "Bhubaneshwar",
    "Ahmedabad", "Asansol/Durgapur", "Belgaum", "Dehradun", "Goa", "Hubli–Dharwad", "Jamshedpur",
    "Pondicherry", "Ranchi"
  ].map((city, index) => (
    <a
      key={index}
      href="#consultation"
      className="bg-blue-50 rounded-xl p-4 text-center text-gray-800 font-medium shadow-sm hover:shadow-md transition-shadow border border-blue-100 block cursor-pointer hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-[#01a09e]"
      style={{ textDecoration: "none" }}
    >
      {city}
    </a>
  ))}
</div> */}
  </div>
<div className="flex flex-row justify-center gap-2 sm:gap-4 w-full max-w-md mx-auto">
  <a
    href="tel:+911140847007"
    className="w-1/2 sm:w-auto bg-white text-[#01a09e] border-2 border-[#01a09e] hover:bg-gray-100 font-semibold px-3 py-2 sm:px-6 sm:py-3 rounded-lg flex items-center justify-center transition-colors duration-200 text-sm sm:text-base"
  >
    <PhoneCall className="h-5 w-5 mr-2" />
    <span>+91 011-408-47007</span>
  </a>
  <a
    href="#consultation"
    className="w-1/2 sm:w-auto bg-[#01a09e] border-2 border-[#01a09e] text-white hover:bg-[#01807e] font-semibold px-3 py-2 sm:px-6 sm:py-3 rounded-lg flex items-center justify-center transition-colors duration-200 text-sm sm:text-base"
  >
    Schedule a Consultation
  </a>
</div>
</section>
 <HospitalTreatmentsShowcase />
   <section id="contact" className="py-16 bg-gradient-to-r from-[#01a09e] to-[#029d9b] text-white">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">Ready to Get Started?</h2>
        <p className="text-xl mb-8 max-w-2xl mx-auto">
          Contact us today to schedule a consultation and learn more about our home healthcare services.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4">
        <a
  href="tel:+911140847007"
  className="bg-white text-[#01a09e] hover:bg-gray-100 font-semibold px-6 py-3 rounded-lg flex items-center justify-center transition-colors duration-200"
>
  <PhoneCall className="h-5 w-5 mr-2" />
 +91 011-408-47007
</a>

         <a
  href="#consultation"
  className="bg-transparent border border-white text-white hover:bg-white/10 font-semibold px-6 py-3 rounded-lg transition-colors duration-200"
>
  Schedule a Consultation
</a>
        </div>
      </div>
    </section>
    </div>
  );
};

export default Homecare;